// Cambridge A2 Flyers vocab.js — Week 35
export default {
  vocab: [
  {
    "word": "recycling",
    "definition_en": "the process of converting waste into reusable material",
    "definition_vi": "tái chế",
    "example": "Put empty plastic bottles into recycling bins.",
    "ipa": "/ˌriːˈsaɪ.klɪŋ/"
  },
  {
    "word": "litter",
    "definition_en": "rubbish left lying in an open public place",
    "definition_vi": "rác thải công cộng",
    "example": "Do not drop litter on the grass.",
    "ipa": "/ˈlɪt.ər/"
  },
  {
    "word": "environment",
    "definition_en": "the natural world as a whole or in a particular area",
    "definition_vi": "môi trường",
    "example": "We must care for our urban environment.",
    "ipa": "/ɪnˈvaɪ.rən.mənt/"
  },
  {
    "word": "protective",
    "definition_en": "serving or intended to protect someone or something",
    "definition_vi": "bảo hộ",
    "example": "Wear protective gloves when picking up trash.",
    "ipa": "/prəˈtek.tɪv/"
  },
  {
    "word": "scattered",
    "definition_en": "thrown around in various directions",
    "definition_vi": "vứt bừa bãi",
    "example": "Plastic wrappers were scattered on the grass.",
    "ipa": "/ˈskæt.əd/"
  },
  {
    "word": "supertrees",
    "definition_en": "tall plant-covered towers that harvest rainwater and solar energy",
    "definition_vi": "siêu cây công nghệ",
    "example": "Singapore built tall futuristic supertrees.",
    "ipa": "/ˈsuː.pə.triːz/"
  },
  {
    "word": "urban",
    "definition_en": "in, relating to, or characteristic of a town or city",
    "definition_vi": "thuộc đô thị",
    "example": "Urban green parks improve city air quality.",
    "ipa": "/ˈɜː.bən/"
  },
  {
    "word": "carbon",
    "definition_en": "a chemical element present in carbon dioxide",
    "definition_vi": "khí các-bon",
    "example": "Trees absorb carbon dioxide to clean air.",
    "ipa": "/ˈkɑː.bən/"
  },
  {
    "word": "rainwater",
    "definition_en": "water that has fallen as rain",
    "definition_vi": "nước mưa",
    "example": "Supertrees harvest rainwater for plants.",
    "ipa": "/ˈreɪnˌwɔː.tər/"
  },
  {
    "word": "generate",
    "definition_en": "produce or create something like energy or power",
    "definition_vi": "tạo ra",
    "example": "Solar panels generate clean electrical power.",
    "ipa": "/ˈdʒen.ə.reɪt/"
  },
  {
    "word": "nature",
    "definition_en": "the physical world including plants, animals, and landscapes",
    "definition_vi": "thiên nhiên",
    "example": "Protecting nature is our shared responsibility.",
    "ipa": "/ˈneɪ.tʃər/"
  },
  {
    "word": "effort",
    "definition_en": "a vigorous or determined attempt to achieve something",
    "definition_vi": "nỗ lực",
    "example": "Their great cleaning effort paid off.",
    "ipa": "/ˈef.ət/"
  },
  {
    "word": "volunteer",
    "definition_en": "a person who freely offers to take part in an enterprise",
    "definition_vi": "tình nguyện viên",
    "example": "Many volunteers joined the weekend park cleanup.",
    "ipa": "/ˌvɒl.ənˈtɪər/"
  },
  {
    "word": "pollution",
    "definition_en": "the presence in the environment of a substance that has harmful effects",
    "definition_vi": "sự ô nhiễm",
    "example": "Plastic pollution hurts fish and sea birds.",
    "ipa": "/pəˈluː.ʃən/"
  },
  {
    "word": "community",
    "definition_en": "a group of people living in the same place or having a particular characteristic",
    "definition_vi": "cộng đồng",
    "example": "Our local community loves the green park.",
    "ipa": "/kəˈmjuː.nə.ti/"
  },
  {
    "word": "biodiversity",
    "definition_en": "the variety of plant and animal life in a habitat",
    "definition_vi": "đa dạng sinh học",
    "example": "Parks support biodiversity in big cities.",
    "ipa": "/ˌbaɪ.əʊ.daɪˈvɜː.sə.ti/"
  },
  {
    "word": "oxygen",
    "definition_en": "a colorless reactive gas essential to human respiration",
    "definition_vi": "khí ô-xy",
    "example": "Green leaves produce fresh oxygen.",
    "ipa": "/ˈɒk.sɪ.dʒən/"
  },
  {
    "word": "sustainable",
    "definition_en": "able to be maintained at a certain rate or level",
    "definition_vi": "bền vững",
    "example": "Solar power is a sustainable energy source.",
    "ipa": "/səˈsteɪ.nə.bəl/"
  },
  {
    "word": "wildlife",
    "definition_en": "wild animals collectively; native fauna of a region",
    "definition_vi": "động vật hoang dã",
    "example": "City trees provide homes for wildlife.",
    "ipa": "/ˈwaɪld.laɪf/"
  },
  {
    "word": "beautify",
    "definition_en": "improve the appearance of a place",
    "definition_vi": "làm đẹp",
    "example": "Planting flowers helps beautify our neighborhood.",
    "ipa": "/ˈbjuː.tɪ.faɪ/"
  }
]
};
